/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
export var StyleProperties;
(function (StyleProperties) {
    StyleProperties["FillPattern"] = "abc:style:fill:pattern";
    StyleProperties["FillColor1"] = "abc:style:fill:color1";
    StyleProperties["FillColor2"] = "abc:style:fill:color2";
    StyleProperties["StrokeColor"] = "abc:style:stroke:color";
    StyleProperties["StrokeWidth"] = "abc:style:stroke:width";
    StyleProperties["TextValue"] = "abc:style:text:value";
    StyleProperties["TextColor"] = "abc:style:text:color";
    StyleProperties["TextSize"] = "abc:style:text:size";
    StyleProperties["TextFont"] = "abc:style:text:font";
    StyleProperties["TextOffsetX"] = "abc:style:text:offset-x";
    StyleProperties["TextOffsetY"] = "abc:style:text:offset-y";
    StyleProperties["TextRotation"] = "abc:style:text:rotation";
    StyleProperties["TextAlignment"] = "abc:style:text:alignment";
    StyleProperties["PointIcon"] = "abc:style:point:icon";
    StyleProperties["PointSize"] = "abc:style:point:size";
    StyleProperties["PointColor"] = "abc:style:point:color";
    StyleProperties["ZIndex"] = "abc:style:z-index";
})(StyleProperties || (StyleProperties = {}));
export var FillPatterns;
(function (FillPatterns) {
    FillPatterns["Flat"] = "abc:style:fill:flat";
    FillPatterns["Circles"] = "abc:style:fill:circles";
    FillPatterns["Squares"] = "abc:style:fill:squares";
    FillPatterns["HatchingVertical"] = "abc:style:fill:hatching:vertical";
    FillPatterns["HatchingHorizontal"] = "abc:style:fill:hatching:horizontal";
    FillPatterns["HatchingObliqueRight"] = "abc:style:fill:hatching:oblique:right";
    FillPatterns["HatchingObliqueLeft"] = "abc:style:fill:hatching:oblique:left";
})(FillPatterns || (FillPatterns = {}));
//# sourceMappingURL=StyleProperties.js.map